import { COLORS } from "components/consts";

export const deleteIconWrapperStyle = {
  padding: 0,
  minWidth: "fit-content",
  color: COLORS.white,
};
